import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import { Dialog } from 'vant';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import VueResource from 'vue-resource'

// 👇 新增：导入路由（必须加）
import router from './router'

Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(VueResource)
Vue.use(Dialog)
Vue.use(ElementUI)

new Vue({
  // 👇 新增：注入路由
  router,
  render: h => h(App),
}).$mount('#app')